import {
    initPayment,
    acceptPayment,
    payPalInitPayemnt,
    payPalAcceptPayment,
    addonFetch
} from "@/api";

const defaultState = {}
const state = () => ({})

const getters = {}

const mutations = {}

const actions = {
    async initPayment({ getters }, payload) {
        const response = await initPayment({ ...payload, web_user_uuid: getters.userUuid })
        return response
    },

    async acceptPayment({ getters }, payload) {
        const response = await acceptPayment({ ...payload, web_user_uuid: getters.userUuid })
        return response
    },

    async payPalInitPayemnt({ getters }, payload) {
        const response = await payPalInitPayemnt({ ...payload, web_user_uuid: getters.userUuid })
        return response
    },

    async payPalAcceptPayemnt({ getters }, payload) {
        try {
            const response = await payPalAcceptPayment({ ...payload, web_user_uuid: getters.userUuid })
            return response
        } catch (error) {
            console.error(error)
            return error;
        }
    },

    async addonFetch({ getters }, payload) {
        const response = await addonFetch({ ...payload, web_user_uuid: getters.userUuid })
        return response
    }

}

export default {
    state,
    getters,
    mutations,
    actions
}
